module.exports = [
  require('./vampiric_mist'),
  require('./venom_troll'),
]
